// composables/useExternalRedirect.js
import { router } from "@inertiajs/vue3";

export function useExternalRedirect() {
    const redirectTo = (url) => {
        // Check if it's an external domain
        const currentDomain = window.location.hostname;
        const urlObject = new URL(url, window.location.origin);

        if (urlObject.hostname !== currentDomain) {
            // External domain - use window.location
            window.location.href = url;
        } else {
            // Same domain - use Inertia
            router.visit(url);
        }
    };

    return { redirectTo };
}
